import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import useFilter from "../Hooks/useFilter";
import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import { message } from "constants/message";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  datePicker: {
    width: "105px",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  anchor: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(1),
    textDecoration: "underline",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function MaterialUIPickers({ onChange, mediaFlag = false }) {
  const filter = useFilter();
  const { state } = useFilter();
  const messages = message();
  const minDate = mediaFlag ? dayjs().subtract(18, "month") 
                            : dayjs().subtract(3, "month");
  const maxDate = dayjs();

  const classes = useStyles();

  const handleClick = (diff) => {
    let toDate = null;
    let fromDate = null;

    switch (diff) {
      case "today":
        toDate = dayjs();
        fromDate = dayjs();
        break;
      case "yesterday":
        toDate = dayjs().subtract(1, "day");
        fromDate = toDate;
        break;
      case "toWeek":
        toDate = dayjs();
        fromDate = dayjs().subtract(6, "day");
        break;
      case "toMonth":
        toDate = dayjs();
        fromDate = toDate.subtract(1, "month");
        break;
      case "oneMonthAgo":
        toDate = dayjs().subtract(1, "month");
        fromDate = toDate.subtract(1, "month");
        break;
      case "twoMonthAgo":
        // TODO: 31日やうるう年の際に挙動
        toDate = dayjs().subtract(2, "month");
        fromDate = toDate.subtract(1, "month");
        break;
    }

    filter.setFilteredDateTo(toDate);
    filter.setFilteredDateFrom(fromDate);
  };

  const dateValidation = (date, type) => {
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM/DD").isValid()) {
      if (type == "from") {
        const toDateTime = dayjs(state.filteredDateTo).format("YYYY-MM-DD 00:00:00")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toDateTime).isSameOrAfter(dayjs(selectedDateTime)))){
          filter.setFilteredDateFrom(dayjs(date));
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromDateTime = dayjs(state.filteredDateFrom).format("YYYY-MM-DD 00:00:00")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromDateTime).isSameOrBefore(dayjs(selectedDateTime)))) {
          filter.setFilteredDateTo(dayjs(date));
        } else {
          alert(messages.validation.dateRang);
        }
      }
    }
    return;
  }

  const dateError = (error, value) => {
    if (error) {
      setIsdisable(true);
    }
    return;
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid item>
          <Grid container alignItems="flex-end">
            <DatePicker
              format="yyyy/MM/dd"
              margin="normal"
              value={state.filteredDateFrom}
              minDate={minDate}
              minDateMessage={
                (messages.validation.minDate).replace(
                  "$1",
                  minDate.format("YYYY-MM-DD")
                )
              }
              maxDate={maxDate}
              maxDateMessage={
                (messages.validation.maxDate).replace(
                  "$1",
                  maxDate.format("YYYY-MM-DD")
                )
              }
              onError={(error, value) => dateError(error, value)}
              onChange={(date) => dateValidation(date, "from")}
              className={classes.datePicker}
            />
            <div className={classes.divider}>〜</div>
            <DatePicker
              margin="normal"
              format="yyyy/MM/dd"
              value={state.filteredDateTo}
              minDate={minDate}
              minDateMessage={
                (messages.validation.minDate).replace(
                  "$1",
                  minDate.format("YYYY-MM-DD")
                )
              }
              maxDate={maxDate}
              maxDateMessage={
                (messages.validation.maxDate).replace(
                  "$1",
                  maxDate.format("YYYY-MM-DD")
                )
              }
              onError={(error, value) => dateError(error, value)}
              onChange={(date) => dateValidation(date, "to")}
              className={classes.datePicker}
            />
            <div className={classes.divider}></div>
            <FormControl className={classes.formControl}>
              <InputLabel id="posi-tabs-label">簡単範囲設定</InputLabel>
              <Select
                labelId="posi-tabs-label"
                id="posi-tabs"
                value=""
                onChange={(event) => {
                  handleClick(event.target.value);
                }}
                onClose={() => {
                  setTimeout(() => {
                    document.activeElement.blur();
                  }, 0);
                }}
              >
                <MenuItem value="today">今日</MenuItem>
                <MenuItem value="yesterday">昨日</MenuItem>
                <MenuItem value="toWeek">直近7日</MenuItem>
                <MenuItem value="toMonth">直近1ヶ月</MenuItem>
                <MenuItem value="oneMonthAgo">1ヶ月前</MenuItem>
                <MenuItem value="twoMonthAgo">2ヶ月前</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
    </MuiPickersUtilsProvider>
  );
}
